import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import GlobalStyle from '../../../src/styles/GlobalStyle';
import fallbacklogo from '../../../src/assets/images/fallback_logo.png';
import fallbackImg from '../../../src/assets/images/fallback_img.png';

const FALLBACKERROR_style = {
  paper: {textAlign: 'center',margin:'0 auto', padding: '40px', width:'50%',backgroundColor:'#fff'},
  textContainer: {textAlign:'left',paddingLeft:0,color:'#ff0000'},
  cardBody: {cursor: 'pointer',marginTop:10},
  reloadFunc: {cursor: 'pointer', color: '#0077FF',position: 'absolute',top: 13,paddingLeft: 10},
  errorDetails: {color: '#000'},
  errorInfoContainer :{height: 103, minHeight: 103,overflowY: 'scroll',overflowX: 'hidden'},
  imgContainer: {display: 'flex',justifyContent: 'center',alignItems: 'center'},
}

class FallbackError extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
    };
  }

  goBack() {
    this.props.history.goBack();
    setTimeout(() => {
      window.location.reload();
    }, 400);
  }
  reloadPage(){
    window.location.reload();
  }
  
  render() {
    const { classes } = this.props;
    return (
      <fallback-error-container>
        <Container component="main" minwidth="sm" className="fallback">
          <Grid container spacing={3}>
            <Grid item sm={12}>
                <Paper className={classes.paper} style={FALLBACKERROR_style.paper}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} className="fallbackIcon">
                      <Avatar src={fallbacklogo} className="fallback-error-icon" alt="fallback icon" />
                    </Grid>
                    <Grid item xs={12} sm={8} style={FALLBACKERROR_style.textContainer}>
                      There is an error while loading this page!
                      
                    </Grid>
                    <Grid item xs={12} sm={4} className="fallback-icon" style={{textAlign:'center'}}>
                      <Avatar src={fallbackImg} alt="fallback icon" />
                    </Grid>
                    <Grid item xs={12} className="">
                      <Button type="submit" color="default" onClick={this.goBack.bind(this)} style={{marginRight:5}} >
                          Back
                      </Button>
                      <Button type="submit" color="default" onClick={this.reloadPage}>                      
                        Reload this page
                      </Button>
                    </Grid>
                  </Grid>
                </Paper>
            </Grid>
          </Grid>
        </Container>
      </fallback-error-container>
    )
  }
}


export default withStyles(GlobalStyle)(FallbackError);